import { MARKETS, UI } from "../data/content";
import { Reveal, HeroBand, CapCard, ContactModule, usePageMeta } from "../components/kit";

export default function MarketsHub() {
  usePageMeta(`${UI.hubs.markets.title} | KairosHK`, UI.hubs.markets.standfirst);
  return (
    <div data-testid="markets-hub-page">
      <HeroBand image="skyline" eyebrow={UI.nav.markets} title={UI.hubs.markets.title}
        standfirst={UI.hubs.markets.standfirst}
        compact testId="markets-hero" />
      <section className="k-section">
        <div className="k-container">
          <Reveal className="max-w-4xl mb-14">
            <p className="text-lg leading-relaxed text-ink-muted">{UI.hubs.markets.p1}</p>
          </Reveal>
          <div className="grid md:grid-cols-2 gap-6 mb-16">
            {MARKETS.map((m, i) => (
              <CapCard key={m.slug} to={`/markets/${m.slug}`} title={m.name} body={m.card} i={i} testId={`market-card-${m.slug}`} />
            ))}
          </div>
          <ContactModule />
        </div>
      </section>
    </div>
  );
}
